import { API } from '@ospace/shared'

export const ErrorLogging = () => {
  const logErrorBoundaryError = async (err: object) => {
    return API.post('client', '/client-logging/error-boundary', { body: err })
  }
  return { logErrorBoundaryError }
}
